import React from "react";
import imgrd1 from "../../../assets/Images/r-d/rd_7.jpg";

const Research_Development_sixth = () => {
  const reasons = [
    {
      number: "01",
      title: "Custom Formula Development",
      description:
        "Exclusive formulations based on your target market and health category.",
    },
    {
      number: "02",
      title: "Flavor & Sensory Development",
      description:
        "Orange, lemon, mixed berry, mango, cola, and customized flavor systems.",
    },
    {
      number: "03",
      title: "White Label Effervescent Solutions",
      description:
        "Ready-to-launch formulations with branding support.",
    },
    {
      number: "04",
      title: "Export Documentation Support",
      description:
        "International compliance assistance for global markets.",
    },
  ];

  return (
    <section className="w-full bg-white py-12 md:py-16 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-12 items-center mb-12 md:mb-16">
          <div className="relative">
            {/* <span className="absolute -top-7 -left-4 w-2 h-2 rounded-full bg-[#A9C32C]"></span> */}

            <img
              src={imgrd1}
              alt="R&D Partner"
              className="w-full h-[280px] sm:h-[420px] object-cover rounded-[40px]"
            />
          </div>

          <div>
            <h3 className="text-3xl sm:text-4xl md:text-5xl font-serif text-[#355931] leading-tight">
              Custom Effervescent Tablet {" "}
              
              <span className="bg-gradient-to-r from-[#355931] via-[#6b8f4e] to-[#A9C32C] bg-clip-text text-transparent">
               Developement Support
              </span>
            </h3>

            <p className="mt-6 text-gray-500 text-sm md:text-base leading-7 max-w-2xl">
              Partner with Nutra Like to benefit from strong formulation
              knowledge, customized solutions, reliable development support, and
              quality-driven manufacturing practices.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-12">
          {reasons.map((item, index) => (
            <div key={index} className="flex gap-5 items-start">
              <h3 className="text-4xl md:text-5xl font-bold text-[#355931] leading-none">
                {item.number}
              </h3>

              <div>
                <h4 className="text-lg md:text-xl font-bold text-[#222] mb-3">
                  {item.title}
                </h4>

                <p className="text-gray-500 text-sm md:text-base leading-7">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Research_Development_sixth;